import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledCompetitiveResultsContainer = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    flex-grow: 1;
    min-height: 0;
`;
